export default function ($rootScope, $http, $q, $interval, $document) {
    return {
        on: false,
        timeLeft: 300,
        enable() {
            let el = document.getElementById('screenSaver');
            el.className = '';
            this.on = true;
        },

        disable() {
            let el = document.getElementById('screenSaver');
            el.className = 'hide';
            this.on = false;
            this.timeLeft = 300;
        },

        init() {
            let tmp = 0,
                current = 0;

            let promise = $interval(() => {
                if ((tmp === current) && (this.timeLeft === 0) && !this.on) {
                    this.enable();
                } else if (!this.on) {
                    this.timeLeft -= 1;
                }
            }, 1000);

            $document.bind('mousemove', (e) => {
                this.timeLeft = 300;
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/screenSaver.js